export default __webpack_public_path__ + "adc775c8dd2d1c1a80c0efcb4d1a4cd9.svg";